import { PureComponent, ReactNode } from 'react';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import {
    GO_TO_CHANGE_DOC,
    GO_TO_LOGIN,
    GO_TO_LOGOUT,
    GO_TO_SETUP_APP,
    INIT,
    OUT_PAGES,
} from '../routes/paths';
import { Actions } from '../store/actions';
import { GlobalState } from '../store/reducers';
import { getIsSettingUp } from '../store/selectors/session';
import setupRedux from '../store/setupAppRedux';
import AppLoader from './common/AppLoader';
import { getMySingleDoctorId, isSingleDoctorAccess } from '../store/idbHandler';

import { fetchMyProfilesAction } from '../store/actions/login';
import { getDefiniteMActiveId } from '../store/localstorage';
import backFillPx from '../backfill-rx';

interface Props {
    dispatch: ThunkDispatch<GlobalState, null, Actions>;
    children: ReactNode;
    isSettingUp: boolean;
}

type State = {
    isLoading: boolean;
    waitForSetup: boolean;
    isAccessControlSetup: boolean;
};

class LoadApp extends PureComponent<Props, State> {
    state: State = {
        isLoading: true,
        waitForSetup: true,
        isAccessControlSetup: false,
    };

    componentDidMount = async (): Promise<void> => {
        const { dispatch } = this.props;
        try {
            if (
                window.location.pathname.startsWith(OUT_PAGES) ||
                window.location.pathname.startsWith('/proxy/') ||
                window.location.pathname === INIT ||
                window.location.pathname === GO_TO_LOGIN ||
                window.location.pathname === GO_TO_LOGOUT ||
                window.location.pathname === GO_TO_CHANGE_DOC ||
                window.location.pathname === GO_TO_SETUP_APP
            ) {
                // most prob iframe pages
                // outside of app
                this.setState({
                    waitForSetup: false,
                    isAccessControlSetup: true,
                });
                return;
            }

            const onSuccess = () => {
                this.setState({
                    isLoading: false,
                });
            };

            // TODO: should be moved to getCurrentMActiveId()
            const docId = isSingleDoctorAccess()
                ? getMySingleDoctorId()
                : localStorage.getItem('activeId');

            if (!docId) {
                window.location.replace(GO_TO_LOGIN);
                this.setState({
                    waitForSetup: false,
                });
                return;
            }

            await setupRedux(
                dispatch,
                docId,
                onSuccess,
                () => {
                    this.setState({
                        isAccessControlSetup: true,
                    });
                },
                undefined,
                getDefiniteMActiveId(),
            );

            this.props.dispatch(fetchMyProfilesAction(false));

            // To be removed after a week
            backFillPx();
        } catch (e) {
            console.error(e);
        }
    };

    render(): ReactNode {
        const { children, isSettingUp } = this.props;
        const { waitForSetup, isAccessControlSetup } = this.state;

        if ((isSettingUp && waitForSetup) || !isAccessControlSetup) {
            return (
                <div className="flex flex-1 flex-auto w-full h-full items-center justify-center">
                    <AppLoader />
                </div>
            );
        }
        return children;
    }
}

export default connect((state: GlobalState) => ({
    isSettingUp: getIsSettingUp(state),
}))(LoadApp);
